import { useState } from 'react';

import { SearchBarDialog } from '#src/components/navigation/AppNavigation/SearchBar/SearchBarDialog/index.tsx';
import { NavItem } from '#src/components/navigation/NavItem/index.tsx';

type Props = React.ComponentProps<typeof NavItem>;
export const SearchNavItem = (props: Props) => {
  const [searchDialogOpened, setSearchDialogOpened] = useState(false);

  return (
    <>
      <NavItem {...props} onClick={() => setSearchDialogOpened(true)} />
      <SearchBarDialog
        open={!!searchDialogOpened}
        onClose={() => setSearchDialogOpened(false)}
      />
    </>
  );
};
